var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeOon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 1200,
    viewBox: "0 0 1200 1200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_87528_68974)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 1200,
    fill: "#06038D"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_87528_68974)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1159.52,
    cy: 47.9644,
    r: 324.287,
    fill: "#FF7575"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_87528_68974)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.9684,
    cy: 1220.21,
    r: 324.287,
    fill: "#00C9FF"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 857.092,
    y: 504,
    width: 76,
    height: 96,
    rx: 38,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.447 786.775C866.487 786.775 842.638 781.244 821.9 770.184C801.507 759.123 785.607 743.742 774.201 724.041C762.795 703.994 757.092 681.008 757.092 655.085V544.134C757.092 518.557 762.795 495.917 774.201 476.216C785.607 456.514 801.507 441.306 821.9 430.591C842.638 419.531 866.487 414 893.447 414C920.753 414 944.602 419.531 964.995 430.591C985.734 441.306 1001.81 456.514 1013.21 476.216C1024.62 495.917 1030.32 518.557 1030.32 544.134V655.085C1030.32 681.008 1024.62 703.994 1013.21 724.041C1001.81 744.088 985.734 759.642 964.995 770.702C944.602 781.417 920.753 786.775 893.447 786.775ZM893.447 724.041C912.458 724.041 927.839 717.992 939.59 705.895C951.342 693.797 957.218 677.725 957.218 657.678V543.616C957.218 523.569 951.342 507.496 939.59 495.399C928.184 482.956 912.803 476.734 893.447 476.734C874.437 476.734 859.056 482.956 847.304 495.399C835.898 507.496 830.195 523.569 830.195 543.616V657.678C830.195 677.725 835.898 693.797 847.304 705.895C859.056 717.992 874.437 724.041 893.447 724.041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.092 474.66C721.092 476.388 720.401 477.943 719.018 479.326C717.981 480.363 716.599 480.881 714.871 480.881H544.815C543.087 480.881 542.223 481.745 542.223 483.474V563.835C542.223 565.563 543.087 566.428 544.815 566.428H656.284C658.013 566.428 659.395 567.119 660.432 568.501C661.815 569.538 662.506 570.921 662.506 572.649V622.94C662.506 624.668 661.815 626.224 660.432 627.606C659.395 628.643 658.013 629.161 656.284 629.161H544.815C543.087 629.161 542.223 630.026 542.223 631.754V715.745C542.223 717.473 543.087 718.337 544.815 718.337H714.871C716.599 718.337 717.981 719.028 719.018 720.411C720.401 721.448 721.092 722.83 721.092 724.558V774.849C721.092 776.578 720.401 778.133 719.018 779.515C717.981 780.552 716.599 781.071 714.871 781.071H475.341C473.613 781.071 472.058 780.552 470.675 779.515C469.638 778.133 469.12 776.578 469.12 774.849V424.369C469.12 422.641 469.638 421.258 470.675 420.221C472.058 418.839 473.613 418.147 475.341 418.147H714.871C716.599 418.147 717.981 418.839 719.018 420.221C720.401 421.258 721.092 422.641 721.092 424.369V474.66Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.393 785.219C264.742 785.219 240.547 780.899 219.809 772.258C199.07 763.271 182.998 750.655 171.592 734.41C160.531 717.819 155.001 698.636 155.001 676.861V665.454C155.001 663.726 155.519 662.344 156.556 661.307C157.939 659.924 159.494 659.233 161.223 659.233H220.327C222.055 659.233 223.438 659.924 224.475 661.307C225.857 662.344 226.549 663.726 226.549 665.454V673.231C226.549 687.057 232.943 698.809 245.732 708.487C258.521 717.819 275.803 722.485 297.578 722.485C315.897 722.485 329.55 718.683 338.536 711.079C347.523 703.129 352.017 693.451 352.017 682.045C352.017 673.75 349.251 666.837 343.721 661.307C338.191 655.431 330.587 650.419 320.909 646.271C311.577 641.778 296.541 635.729 275.803 628.125C252.645 620.175 232.943 612.053 216.698 603.758C200.798 595.462 187.318 584.229 176.258 570.058C165.543 555.541 160.186 537.74 160.186 516.656C160.186 495.917 165.543 477.771 176.258 462.217C186.973 446.664 201.835 434.739 220.846 426.444C239.856 418.148 261.804 414 286.69 414C312.959 414 336.29 418.667 356.683 427.999C377.421 437.331 393.493 450.466 404.9 467.402C416.651 483.993 422.527 503.349 422.527 525.47V533.247C422.527 534.975 421.836 536.53 420.453 537.913C419.417 538.95 418.034 539.468 416.306 539.468H356.683C354.954 539.468 353.399 538.95 352.017 537.913C350.98 536.53 350.461 534.975 350.461 533.247V529.099C350.461 514.582 344.412 502.312 332.315 492.288C320.563 481.919 304.318 476.734 283.58 476.734C267.334 476.734 254.546 480.191 245.213 487.104C236.227 494.016 231.733 503.522 231.733 515.619C231.733 524.26 234.326 531.518 239.51 537.394C245.041 543.27 252.99 548.628 263.36 553.467C274.074 557.96 290.492 564.182 312.613 572.131C337.154 581.118 356.337 589.068 370.163 595.981C384.334 602.893 396.95 613.263 408.01 627.088C419.417 640.568 425.12 658.196 425.12 679.971C425.12 712.462 413.195 738.212 389.346 757.222C365.497 775.887 333.179 785.219 292.393 785.219Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_87528_68974",
    x: 435.23,
    y: -676.322,
    width: 1448.57,
    height: 1448.57,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 200,
    result: "effect1_foregroundBlur_87528_68974"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_87528_68974",
    x: -712.318,
    y: 495.928,
    width: 1448.57,
    height: 1448.57,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 200,
    result: "effect1_foregroundBlur_87528_68974"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_87528_68974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 1200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeOon);
export default __webpack_public_path__ + "static/media/SEOon.f10c53daa843ad971358f46fd6389b19.svg";
export { ForwardRef as ReactComponent };